import { useAchievements } from "api/achievements";
import { useAppSelector } from "app/hooks";
import { MoreElements } from "components/MoreElements/MoreElements";
import { isArray } from "lodash";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { useStyles } from "../ConditionReadOnly";

export const AchievementsDropdown = ({
  ids,
  maxVisibleConditionDataCount,
}: {
  ids: string[];
  maxVisibleConditionDataCount: number;
}) => {
  const classes = useStyles();
  const { useAchievementData } = useAchievements();
  const { data: achivements } = useAchievementData(ids);
  const { code } = useAppSelector(selectDefaultLanguageData);
  const achivementList = isArray(achivements)
    ? achivements.map(
        (achievement) =>
          achievement?.translations[code]?.name || achievement?.achievementId,
      )
    : [];
  return (
    <>
      {achivementList
        ?.slice(0, maxVisibleConditionDataCount)
        ?.map((achievementName, index) => (
          <div key={index} className={classes.box}>
            {achievementName}
          </div>
        ))}
      <MoreElements
        totalItemsNumber={achivementList.length}
        tooltipData={{
          type: "labels",
          data: achivementList.slice(maxVisibleConditionDataCount),
        }}
      />
    </>
  );
};
